import React, { Component, Fragment } from 'react';
import d1 from '../assets/data/job_data'
import d2 from '../assets/data/project_data'
import './WorkDetail.css'

const data = d1.concat(d2)

export default class WorkDetail extends Component {
  render() {
    const data_item = data.find(d => d.detailSlug === this.props.match.params.id)
    return (
      <section id='work-detail'>
        <div className="container">
          <h2 className=''>{data_item.name}</h2>
          <hr className=' special' />
          <p className='text-faded'>
            {data_item.description2}
          </p>
          {
            data_item.description3 &&
            <p className='text-faded'>
              {data_item.description3}
            </p>
          }
            {
              data_item.images && 
              data_item.images.map((img, i) => (
                <div className="app-data" key={i}>
                  <img
                    className='col s10 m6 l4 offset-s1 offset-m3 offset-l4 responsive-img'
                    src={img}
                    />
                  <div className="text-faded center-align"><em>{data_item.moreDetail[i]}</em></div>
                </div>
            ))
            }
        </div>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/WorkDetail.js